module.exports = __webpack_public_path__ + "img/FR16560.a56d6fb4.svg";